document.addEventListener('DOMContentLoaded', function() {
    
    // Меню по личному кабинету
    
    const $menu = $('#modalMenuAccount');
    
    if (!$menu.length) {
        return;
    }
    
    if (typeof window.Header.methods !== 'object' || window.Header.methods === null) {
        window.Header.methods = {};
    }
    
    window.Header.methods.openAccountMenu = function() {
        $.fancybox.open({
            src: $menu[0],
            type: 'html',
            
            animationDuration: 300,
            animationEffect: 'mobile-menu-account',
            
            closeExisting: true,
            smallBtn: false,
            touch: false,
            autoFocus: false,
            
            baseTpl:
                '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-stage"></div>' +
                '</div>',
            baseClass: "fancybox-menu-mobile",
            
            clickOutside: "close",
            
            beforeShow: function(instance, slide) {
                document.dispatchEvent(new CustomEvent('menu.account.beforeOpen', {
                    bubbles: true,
                    cancelable: true
                }));
                
                const modalNavFancybox = slide.$slide[0].closest('.fancybox-container');
                if (modalNavFancybox) {
                    const offsetTop = window.Header.getBottomPosOnScreen();
                    const offsetBottom = window.bottomBar.methods.getPositionTop();
                    modalNavFancybox.style.top = offsetTop + 'px';
                    modalNavFancybox.style.bottom = offsetBottom + 'px';
                    modalNavFancybox.style.height = `calc(100% - ${offsetTop}px - ${offsetBottom}px)`;
                }
            },
            afterShow: function (instance, slide) {
                $menu[0].dispatchEvent(new CustomEvent('menu.account.open', {
                    bubbles: true,
                    cancelable: true
                }));
                
                const scrollerWrap = slide.$slide[0].querySelector('.js-menu-account__content');
                if (scrollerWrap) {
                    new SimpleBar(scrollerWrap);
                }
                
                setTimeout(() => {
                    bodyScrollLock.disableBodyScroll(slide.src.querySelector('.simplebar-content-wrapper'));
                }, 100);
            },
            
            beforeClose: function (instance, slide) {
                document.dispatchEvent(new CustomEvent('menu.account.beforeClose', {
                    bubbles: true,
                    cancelable: true
                }));
            },
            
            afterClose: function (instance, slide) {
                bodyScrollLock.enableBodyScroll(slide.src.querySelector('.simplebar-content-wrapper'));
                
                document.dispatchEvent(new CustomEvent('menu.account.close', {
                    bubbles: true,
                    cancelable: true
                }));
            },
            
            lang: "ru",
            i18n: {
                en: {
                    CLOSE: "Close",
                    NEXT: "Next",
                    PREV: "Previous",
                    ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                    PLAY_START: "Start slideshow",
                    PLAY_STOP: "Pause slideshow",
                    FULL_SCREEN: "Full screen",
                    THUMBS: "Thumbnails",
                    DOWNLOAD: "Download",
                    SHARE: "Share",
                    ZOOM: "Zoom"
                },
                ru: {
                    CLOSE: "Закрыть",
                    NEXT: "След.",
                    PREV: "Пред.",
                    ERROR: "Невозможно загрузить контент. <br/> Пожалуйста, попробуйте позднее.",
                    PLAY_START: "Начать слайдшоу",
                    PLAY_STOP: "Поставить на паузу",
                    FULL_SCREEN: "Во весь экран",
                    THUMBS: "Превью",
                    DOWNLOAD: "Скачать",
                    SHARE: "Поделиться",
                    ZOOM: "Увеличить"
                }
            }
        });
    }
    
    window.Header.methods.closeAccountMenu = function() {
        $.fancybox.close();
    };
});
